import React from 'react';
import { ReturnedItemsListTemplate } from 'themes/modules/order/pages';
import { ReturnedItemsListViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new ReturnedItemsListViewStore(rootStore, componentProps),
	'returnedItemsListViewStore'
)
class ReturnedItemsList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ReturnedItemsListTemplate {...this.props} viewStore={this.props.returnedItemsListViewStore} />;
	}
}

export default ReturnedItemsList;
